module.exports = __webpack_public_path__ + "img/pendiente_c.4dd84daf.png";